import useWindowSize from './useWindowSize'

export default () => {
  const [width, height] = useWindowSize()
  return width <= 600 && height <= 815
}
